import { z } from 'zod';

export const createStudentSchema = z.object({
  firstName: z.string().trim().min(1, 'manage.createStudent.firstNameRequired'),
  lastName: z.string().trim().min(1, 'manage.createStudent.lastNameRequired'),
  email: z
    .string()
    .trim()
    .min(1, 'manage.createStudent.emailInvalid')
    .email('manage.createStudent.emailInvalid'),
});

export type CreateStudentForm = z.infer<typeof createStudentSchema>;
